import { Deserializable } from './deserializable.interface';

/**
 * Container class for report user
 *
 * @export
 * @class ReportUser
 * @implements {Deserializable}
 */
export class ReportUser implements Deserializable {
  public username: string;

  deserialize(input: any): this {
    this.username = input.Username;
    return this;
  }
}
